<template>
    <div>
        <nav class="nav--top top-nav">
            <div class="grid-12 nav-wrapper">
                <div class="col-11 col-sm-9 col-lg-8 col-offset-sm-2 ">
                    <h1 class="logo">
                        <img src="@/assets/acute-logo.jpg" alt="A">cute Colors
                    </h1>
                </div>
                <div class="col-sm-1 col-lg-2">
                    <!-- <div class="bars-wrapper">
                        <font-awesome-icon icon="bars" @click="navTopOpen=!navTopOpen"></font-awesome-icon>
                    </div> -->
                    <!-- <div class="nav-link-wrapper" v-if="navTopOpen">
                        <div class="nav-link">Explore</div>
                        <div v-if="$store.state.authValid" class="nav-link" @click="accountMenuOpen=!accountMenuOpen">{{firstName}}</div>
                        <div v-else class="nav-link" @click="signInModalOpen=true">Sign In</div>
                    </div> -->
                </div>
            </div>
        </nav>
   <!--      <div class="account-menu" v-if="accountMenuOpen && navTopOpen">
            <div class="account-menu-item" @click="$router.push({path:'/profile'})">Profile</div>
            <div class="account-menu-item" @click="accountSignOut">Sign Out</div>
        </div> -->
    </div>
</template>
<style>
    .top-nav{
        background-color: #222;
        color: #FFF;
        height: 75px;
        box-shadow: 0 0 5px rgba(0,0,0,0.5);
    }
    .top-nav .bars-wrapper{
        font-size: 1.5em;
        cursor: pointer;
    }
    .top-nav .logo{
        font-size: 1.5em;
        text-transform: uppercase;
        text-align: center;
        justify-content: center;
        align-items: center;
        width: 100%
    }
    .top-nav .logo img{
        height: 18px;
        padding-right: 4px;
    }
    .top-nav .nav-wrapper{
        align-items: center;
    }
    .top-nav .nav-link-wrapper{
        position: absolute;
        top: 75px;
        right: 0;
        left: 0;
        background-color: #202020;
        z-index: 1000;
        box-shadow: 0 5px 5px rgba(0,0,0,0.5);
    }
    .top-nav .nav-link{
        position: relative;
        padding: 15px;
        cursor: pointer;
        display: block;
        text-align: center;
        background-color: transparent;
        transition: background-color 0.15s ease-in-out;
        border-bottom: solid 1px rgba(0,0,0,0.3);
    }
    .top-nav .nav-link:hover{
        position: relative;
        background-color: rgba(255,255,255,0.05);
    }
    .account-menu{
        position: absolute;
        top: 175px;
        right: 0;
        background-color: #FFF;
        width: 100%;
        z-index: 30;
        box-shadow: 0 5px 5px rgba(0,0,0,0.5);
    }
    .account-menu .account-menu-item
    {
        padding: 15px 0;
        text-align: center;
        cursor: pointer;
        color: #333;
        text-decoration: none;
    }
    .account-menu .account-menu-item:hover{
        background-color: rgba(0,0,0,0.1);
    }
    @media screen and (min-width: 576px){
        .top-nav .bars-wrapper,
        .top-nav .logo{
            font-size: 2em;
        }
        .top-nav .logo img{
            height: 24px;
        }
    }
    @media screen and (min-width: 992px){
        .top-nav .logo{
            font-size: 2.5em;
        }
        .top-nav .logo img{
            height: 30px;
        }
    }
    @media screen and (min-width: 1200px){
        .top-nav .bars-wrapper{
            display: none;
        }
        .top-nav .nav-link-wrapper{
            position: relative;
            top: unset;
            bottom: unset;
            left: unset;
            right: unset;
            background-color: transparent;
            box-shadow: none;
        }
        .top-nav .nav-link{
            display: inline;
            padding: 0 5%;
            margin: 0 2%;
        }
        .top-nav .nav-link:hover{
            background-color: transparent;
        }

        .top-nav .nav-link::after{
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: -5px;
            height: 2px;
            background-color: transparent;
            transition: background-color 0.15s ease-in-out;
        }
        .top-nav .nav-link:hover::after{
            background-color: #FFF;
        }
        .account-menu{
            top: 75px;
            width: 50%;
            max-width: 300px;
        }
        .account-menu .account-menu-item{
            padding: 5% 10%;
        }
    }
</style>
<script type="text/javascript">
     export default{
        data(){
            return {
                navTopOpen:false,
                signInModalOpen:false,
                accountMenuOpen:false,
                firstName:'',
                startingRequest:true,
            };
        },
        methods:{
            topNavResize(){
                if(window.innerWidth>1200){
                    this.navTopOpen=true;
                }else{
                    this.navTopOpen=false;
                }
            },
        },
        mounted(){
            window.addEventListener("resize",this.topNavResize);
            this.topNavResize();
        },
        beforeDestroy(){
            window.removeEventListener("resize",this.topNavResize);
        }
    }
</script>